import { render, staticRenderFns } from "./ApproveRmaRequest.vue?vue&type=template&id=65d497cc&scoped=true"
import script from "./ApproveRmaRequest.vue?vue&type=script&lang=js"
export * from "./ApproveRmaRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d497cc",
  null
  
)

export default component.exports